import React, { useState } from "react";
import { useRouter } from "next/router";

import TwitterIcon from "custom-icons/Twitter.icon";
import FacebookIcon from "custom-icons/Facebook.icon";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkIcon from "@mui/icons-material/Link";
import Tooltip from "@mui/material/Tooltip";

// Components

// Helpers

// Styles
import { useStyles } from "./SocialsLinks.styles";

const SocialsLinks = () => {
  const defaultTooltipText = "Copy Link";
  const [tooltipText, setTooltipText] = useState(defaultTooltipText);
  const classes = useStyles();
  const router = useRouter();
  const url = `${process.env.NEXT_HOST}${router.asPath}`;

  const shareText = "Just found this on VINN marketplace!";
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  const twitterUrl = `http://twitter.com/share?url=${url}&text=${shareText}&count=none`;

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    setTooltipText("Copied!");
  };

  const handleTooltipClose = () => {
    setTooltipText(defaultTooltipText);
  };

  return (
    <div className={classes.iconGroup}>
      <a
        href={fbUrl}
        target="_blank"
        rel="noreferrer"
        aria-label="Share on Facebook"
      >
        <FacebookIcon className={classes.socialIcons} />
      </a>
      <a
        href={twitterUrl}
        target="_blank"
        rel="noreferrer"
        aria-label="Share on Twitter"
      >
        <TwitterIcon className={classes.socialIcons} />
      </a>
      <a
        href={`mailto:?subject=Check out this vehicle!&body=${shareText}%0D%0A${url}`}
        aria-label="Share through Email"
      >
        <EmailOutlinedIcon className={classes.socialIcons} />
      </a>
      <span>
        <Tooltip
          title={tooltipText}
          onClose={handleTooltipClose}
          enterDelay={100}
        >
          <LinkIcon onClick={copyLink} className={classes.socialIcons} />
        </Tooltip>
      </span>
    </div>
  );
};

export default SocialsLinks;
